import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Event = ApplicationRecord.extend({
  attrs: {
    event_name: attr(),
    data: attr(),
    created_at: attr({ persist: false }),
    customer_id: attr(),
    customer: belongsTo({ type: 'customers-customer' }),
    forward_to: attr(),
  },
  static: {
    endpoint: '/events',
    jsonapiType: 'customers-events',
  },
});

export default Event;
